import * as React from 'react';
import { useCardContext } from '../card';
import { Text, TokenTextAppearance, TokenTextColor } from '../../text';
export const CardTitle = ({ title }) => {
    const { emphasis = 'large' } = useCardContext();
    const appearance = {
        small: TokenTextAppearance.headline100,
        large: TokenTextAppearance.headline200,
    }[emphasis];
    return (React.createElement(Text, { appearance: appearance, bold: true, color: TokenTextColor.inherit }, title));
};
